import { createSelector } from 'reselect';

export const selectSystemSlice = state => state.system;

export const selectIsStarting = createSelector(
  selectSystemSlice,
  slice => slice.isStarting
);
